export const homepageToolsData = [
  {
    header: 'My Team - powered by AI',
    description:
      'Get your team rated, optimise your starting 11, plan transfers and predict points for upcoming Gameweeks.',
    link: '/my-team/pick'
  },
  {
    header: 'AI Transfers',
    description:
      "Say goodbye to generic and vague 'tips' that have no application to your squad. Our artificial intelligence recommends the best transfer for every Gameweek based on your team.",
    link: '/my-team/transfers'
  },
  {
    header: 'Mini League Analyser',
    description:
      'Keep your friends close and your mini league opponents closer. Use the analyser to see what your rivals are up to.',
    link: '/my-team/mini-leagues'
  },
  {
    header: 'OPTA Stats',
    description:
      'Keen to nerd a bit more on numbers? OPTA Stats feature is the place for you.',
    link: '/opta'
  },
  {
    header: 'Calendars & Planners',
    description:
      'Remember when you used to play GTA 3 and found the cheat code for unlimited money? Well, this is similar to that, but better.',
    link: '/my-team/pick'
  }
];

export const aiTeamRatingFlowToolsData = [
  {
    header: 'Win your mini-leagues using the power of AI',
    description:
      'Our flagship tool My Team is redefining FPL. Powered by artificial intelligence, My Team analyses thousands of data points and leverages deep learning to deliver you a weekly team rating, recommended transfers specific to your team and the ability to plan for upcoming Gameweeks to always stay ahead of the competition.',
    link: '/my-team/pick'
  },
  {
    header: 'Expert Team Reveals',
    description:
      "We're home to the biggest and best Fantasy managers on the planet, including last year's FPL WINNER, Jonas Labakk. Take the stress out of FPL - see the experts' teams every Gameweek and use their selections to inform your own picks and watch your rank soar.",
    link: '/category/team-reveal'
  },
  {
    header: 'Get the answers you need from our new AI Chatbot',
    description:
      "Our newest feature is like having an AI-powered assistant on hand 24/7. Work with the bot to plan your season of dominance and uncover the hidden gem transfers your rivals aren't considering, so you can do one thing: start winning at FPL.",
    link: '/my-team/pick'
  }
];
